/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {MessageStateInterface} from '@/store/modules/message/types';
import {actions} from '@/store/modules/message/actions';
import {getters} from '@/store/modules/message/getters';
import {mutations} from '@/store/modules/message/mutations';


export const state: MessageStateInterface = {
    messages: [],
};

const namespaced: boolean = true;

export const messageStateModule: Module<MessageStateInterface, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,

};
